export default `float s=2., e, g, l;
  p=abs(mod(p-1.,2.)-1.)-1.;
  for(int j=0;j<8;j++)
    p=1.-abs(p-1.),
    p=p*(l=-1./dot(p,p))-vec3(.1,.3,.1),
    s*=abs(l);
    g+=e=length(p.xz)/s;
  return e;
}`